import { render } from "./PaymentSuccessPage.vue?vue&type=template&id=8fb74ed0&scoped=true"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=js"

import "./PaymentSuccessPage.vue?vue&type=style&index=0&id=8fb74ed0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb74ed0"]])

export default __exports__